import { LogoHeader } from "../../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../../Components/Inicio/NavDesktop";
import { NavMobile } from "../../Components/Inicio/NavMobile";
import { Footer } from "../../Components/Footer/FooterComponent";
import AdminSponsorComponent from "../../Components/Patrocinadores/AdminSponsorComponent";
import { PublicidadSubNav } from '../../Components/Patrocinadores/PublicidadSubNav';

export const AdminSponsorPage = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <PublicidadSubNav tab="sponsor-admin" isAdmin showBackLink />
            <AdminSponsorComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    )
}
